<template>
  <section>
    <b-col
      cols="3"
      class="px-0"
    >
      <b-form-group
        class="w-100 mb-1"
      >
        <b-skeleton
          v-if="loading"
          animation="wave"
          type="input"
        />
        <v-select
          v-else
          v-model="selectedAdType"
          :clearable="false"
          label="text"
          :placeholder="$tk('ClientPortal.Survey.ChooseAdType')"
          :options="correctAdTypes(adTypes)"
          :reduce="adType => adType.value"
          @option:selected="adTypeChange()"
        />
      </b-form-group>
    </b-col>
    <b-card
      class="my-50"
      no-body
    >
      <div class="admin-table--score-debugger">
        <b-skeleton-table
          v-if="loading"
          class="admin-table__data"
          :rows="12"
          :columns="scoreDebuggerColumns.length"
          :table-props="{ bordered: true, striped: true }"
        />
        <vue-good-table
          v-else
          :rows="rows"
          class="admin-table__data"
          :columns="scoreDebuggerColumns"
          :enable-sort="false"
        >
          <template
            slot="table-row"
            slot-scope="props"
          >
            <span v-if="props.column.field == 'ad1' && props.row.title != $tk('Admin.ScoreDebugger.FinalScore')">
              <b-form-input
                v-model.number="rows[props.index].ad1"
                type="number"
                min="0"
                step=".1"
                max="1"
                size="sm"
                @blur="adjustValue(rows[props.index].ad1, props.index, props.row.title, 1)"
              />
            </span>
            <span v-else-if="props.column.field == 'ad2' && props.row.title != $tk('Admin.ScoreDebugger.FinalScore')">
              <b-form-input
                v-model.number="rows[props.index].ad2"
                type="number"
                min="0"
                step=".1"
                max="1"
                size="sm"
                @blur="adjustValue(rows[props.index].ad2, props.index, props.row.title, 2)"
              />
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
        <div class="wrapper-border">
          <div class="winner-wrapper">
            <div class="winner-row">
              <div class="winner-cell--first final-score">
                {{ finalRow.title }}
              </div>
              <div
                class="winner-cell final-score--winner"
                style="width:22%"
              >
                {{ finalRow.ad1 }}
              </div>
              <div
                class="winner-cell final-score"
                style="width:17%"
              >
                {{ finalRow.ad1score }}
              </div>
              <div
                class="winner-cell final-score--winner"
                style="width: 22%"
              >
                {{ finalRow.ad2 }}
              </div>
              <div
                class="winner-cell final-score"
                style="width: 14%"
              >
                {{ finalRow.ad2score }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-card>
    <div class="border-top text-right py-1">
      <div class="mx-auto">
        <b-button
          size="sm"
          class="bg-white ml-50"
          variant="primary"
          :disabled="loading"
          @click="runTest()"
        >
          {{ $tk('ClientPortal.Form.Actions.RunTest') }}
        </b-button>
      </div>
    </div>
  </section>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import ScoringService from '@/api/admin/scoring.service'
import sweetAlert from '@/mixins/sweetAlert'
import notification from '@/mixins/toastification'
import translation from '@/mixins/translate'
import {
  ref, onMounted, reactive,
  computed,
} from '@vue/composition-api'
import store from '@/store'
import vSelect from 'vue-select'

export default {
  components: {
    VueGoodTable,
    vSelect,
  },
  mixins: [notification, sweetAlert],
  setup() {
    const scoreDebuggerColumns = [
      {
        label: translation.methods.$tk('Admin.ScoreDebugger.Title(MultiplierValue)'),
        field: 'title',
        width: '25%',
        sortable: false,
      },
      {
        label: translation.methods.$tk('Admin.ScoreDebugger.Ad#1'),
        field: 'ad1',
        width: '22%',
        sortable: false,
      },
      {
        label: translation.methods.$tk('Admin.ScoreDebugger.Score'),
        field: 'ad1score',
        width: '14%',
        sortable: false,
      },
      {
        label: '',
        field: 'divider',
        width: '3%!important',
        thClass: 'separator-column',
        sortable: false,
      },
      {
        label: translation.methods.$tk('Admin.ScoreDebugger.Ad#2'),
        field: 'ad2',
        width: '22%',
        sortable: false,
      },
      {
        label: translation.methods.$tk('Admin.ScoreDebugger.Score'),
        field: 'ad2score',
        width: '14%',
        sortable: false,
      },
    ]
    const multipliers = computed(() => store.getters.getMultipliers)
    let wrapper = reactive({})
    const rows = reactive([])
    const finalRow = ref({})
    const loading = ref(false)
    const adTypes = ref([])
    const selectedAdType = ref(1)
    const adjustValue = (currentValue, rowIndex, rowType, adNumber) => {
      const correctValue = rowType.includes('Frequency') ? 1 : 0
      if (!currentValue) {
        const updateRow = {
          1: rows[rowIndex].ad1 = correctValue,
          2: rows[rowIndex].ad2 = correctValue,
        }
        /* eslint-disable-next-line no-unused-expressions */
        updateRow[adNumber]
      }
    }
    const buildTableRows = () => {
      wrapper.multipliers.forEach(multiplier => {
        if (multiplier.name === 'frequency') {
          rows.push({
            name: multiplier.name,
            title: `${multiplier.title} (${multiplier.value}.0)`,
            ad1: 1,
            ad1score: '0.00',
            ad2: 1,
            ad2score: '0.00',
          })
        } else {
          rows.push({
            name: multiplier.name,
            title: `${multiplier.title} (${multiplier.value}.0)`,
            ad1: 0,
            ad1score: '0.00',
            ad2: 0,
            ad2score: '0.00',
          })
        }
      })
      finalRow.value = {
        title: translation.methods.$tk('Admin.ScoreDebugger.FinalScore'),
        ad1: '',
        name: 'final',
        ad1score: '0.000',
        ad2: '',
        ad2score: '0.000',
      }
    }
    onMounted(async () => {
      loading.value = true
      await store.dispatch('getScoreMultipliers')
      wrapper = await ScoringService.getScoreMultipliers(1)
      adTypes.value = multipliers.value.adTypes
      selectedAdType.value = multipliers.value.selectedAdType
      buildTableRows()
      loading.value = false
    })
    const runTest = async () => {
      const debugModel = { item1: {}, item2: {} }
      finalRow.value.ad1 = ''
      finalRow.value.ad2 = ''
      rows.forEach(row => {
        if (row.name) {
          debugModel.item1[row.name] = row.ad1
          debugModel.item2[row.name] = row.ad2
        }
      })
      const response = await ScoringService.debuggScoreMultiplier(debugModel, selectedAdType.value)

      let scoreAd1
      let scoreAd2
      Object.keys(response.item1).forEach(key => {
        if (key === 'final') {
          scoreAd1 = response.item1[key]
          finalRow.value.ad1score = response.item1[key].toFixed(3)
        } else {
          const rowIndex = rows.findIndex(row => row.name === key)
          rows[rowIndex].ad1score = response.item1[key].toFixed(2)
        }
      })
      Object.keys(response.item2).forEach(key => {
        if (key === 'final') {
          scoreAd2 = response.item2[key]
          finalRow.value.ad2score = response.item2[key].toFixed(3)
        } else {
          const rowIndex = rows.findIndex(row => row.name === key)
          rows[rowIndex].ad2score = response.item2[key].toFixed(2)
        }
      })
      /* eslint-disable-next-line */
      scoreAd1 > scoreAd2 ? finalRow.value.ad1 = translation.methods.$tk('Admin.ScoreDebugger.Winner') : (scoreAd1 == scoreAd2 ? '' : finalRow.value.ad2 = translation.methods.$tk('Admin.ScoreDebugger.Winner'))
      if (response) {
        notification.methods.success(translation.methods.$tk('ClientPortal.ScoreDebugger.ScoreDebugSuccessfull'))
      } else {
        notification.methods.error(translation.methods.$tk('ClientPortal.ScoreDebugger.SomethingWentWrong'))
      }
    }
    const adTypeChange = async () => {
      wrapper = await ScoringService.getScoreMultipliers(selectedAdType.value)
      rows.splice(0, rows.length)
      finalRow.value = {}
      buildTableRows()
    }
    const correctAdTypes = types => Object.keys(types).map(k => ({ text: types[k], value: parseInt(k, 10) }))

    return {
      wrapper,
      loading,
      scoreDebuggerColumns,
      runTest,
      rows,
      adTypes,
      adjustValue,
      selectedAdType,
      adTypeChange,
      finalRow,
      correctAdTypes,
    }
  },
}
</script>
<style lang="scss">
  @import '@/assets/scss/views/admin/ad-debugger/score-debugger.scss';
</style>
